(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.reduceMotion = {
    attach: function(context, settings) {
      const $motionButton = jQuery('#reduce-motion-button');
      const motionCookieName = 'userPrefersReducedMotion';
      const motionBodyClass = 'reduce-motion';
      let winResizeBounce = null;
      const $body = jQuery('body');

      const userPrefersReducedMotion = function() {
        //IW-update ----
        // return true;
        //end IW-update ----
        //Non-IW ----

        //check if user clicked "reduce motion" button
        if (window.getCookie(motionCookieName) === 'true') {
          // alert('cookie true');
          return true;
        }

        //now, check if the a media query by the name of "(prefers-reduced-motion: reduce)" is found
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          if (!window.getCookie(motionCookieName)) {
            // alert('set cookie');
            window.setCookie(motionCookieName, 'true', 10);
          }
          // alert('no cookie, but match media');
          return true;
        }

        //final check -- force reduce motion on viewports equal to or less than tablets
        if (window.innerWidth < 992) {
          return true;
        }

        //~ Note: There's an issue in Edge browsers on tablets where neither media query match or cookie will be found. This was the impetus for increasing the viewport width when forcing a true result. (CROWN-1352)
        // alert('no cookie and media not found, so return false');
        return false;
        //end Non-IW ----
      };

      const bLazyReducedMotion = function() {

        const reduceMotion = userPrefersReducedMotion();
 
        if (reduceMotion) {
          // alert('reduced motion confirmed');
          jQuery('.field--name-field-animated-can').addClass('reduce-motion');
          jQuery('body').addClass(motionBodyClass);
          jQuery('.b-lazy-reduced-motion').addClass('b-lazy');
        }
        else {
          // alert('remove class');
          jQuery('.b-lazy-reduced-motion').removeClass('b-lazy');
        }
        window.blazy.revalidate();
      };

      jQuery(document).ready(function() {
        bLazyReducedMotion();
      });

      $motionButton.click(function() {
        $body.toggleClass(motionBodyClass);
        if ($body.hasClass(motionBodyClass)) {
          window.setCookie(motionCookieName, 'true', 10);
        }
        else {
          window.setCookie(motionCookieName, 'false', 10);
        }
        location.reload();
      });

      jQuery(window).resize(function() {
        winResizeBounce = setTimeout(function() {
          clearTimeout(winResizeBounce);
          if (window.innerWidth < 992) {
            if (!$body.hasClass(motionBodyClass)) {
              $body.addClass(motionBodyClass);
            }
            jQuery('.b-lazy-reduced-motion:not(.b-lazy)').addClass('b-lazy');
            window.blazy.revalidate();
          }
          else if ($body.hasClass(motionBodyClass) && !userPrefersReducedMotion()) {
            $body.removeClass(motionBodyClass);
          }
        }, 200);
      });
    }
  };
})(jQuery, Drupal);
